// https://coderwall.com/p/i817wa/one-line-function-to-detect-mobile-devices-with-javascript
// ... don't use mobile detection unless you ABSOLUTELY HAVE to

const isMobile =
  (typeof window.orientation !== 'undefined') ||
  (navigator.userAgent.indexOf('IEMobile') !== -1);

export default isMobile;
